import React from 'react';
import { useNavigate } from 'react-router-dom';
import newAddButton from 'assets/images/newAddButton.svg';
import { useAppDispatch, useAppSelector } from 'common/hooks/state';
import { RootState } from 'common/store/store';
import { usePaywall } from 'features/pricing/showPaywall';
import { startUploadFlow } from 'features/UploadDocument/startUploadFlow';
import { showAddType } from './types';

interface AddDocProps extends showAddType {
  hasSubscribed?: boolean;
}

export const AddDoc = ({ showAdd, hasSubscribed = true }: AddDocProps) => {
  const navigate = useNavigate();
  const { showPaywall } = usePaywall();
  const dispatch = useAppDispatch();
  const user = useAppSelector((state: RootState) => state.auth.user);
  const handleAddClick = async () => {
    await startUploadFlow({
      dispatch,
      navigate,
      hasSubscribed,
      showPaywall,
      user,
      entryPathname: window.location.pathname,
      entrySearch: window.location.search,
      source: 'dashboard_add',
    });
  };

  return (
    <div className="font-bold text-gray-700 z-10 flex items-center justify-center font-mono font-[64px]">
      <button type="button" onClick={handleAddClick} data-cy="add-doc" data-tour="add-doc">
        <img src={newAddButton} style={{ width: 78, height: 78 }} alt="add" />
      </button>
    </div>
  );
};

export default AddDoc;
